import React from "react";

import { GeneratingReassessmentScreen } from "@pages/ClinicalReportDetails/ReportPage/Components/GeneratingReassessmentScreen";
import { ReportPage } from "@pages/ClinicalReportDetails/ReportPage/ReportPage";
import { useClinicalReportDetailsData } from "@providers/ClinicalReportDetailsProvider";

export const NarrativePage: React.FC = () => {
  const { isNarrativeMappingInProgress } = useClinicalReportDetailsData();

  // The learning-tree mapping is still writing these fields; editing them now
  // would race it. Only the mapping holds this page, and only this page: it
  // re-runs on every programming refresh, which shouldn't blank Programming.
  if (isNarrativeMappingInProgress) {
    return <GeneratingReassessmentScreen message="Refreshing relevant report fields from EHR" />;
  }

  return <ReportPage />;
};
